export default __webpack_public_path__ + "static/media/stories-icon-3.4668d37c.svg";